import { useFormik } from "formik";
import * as Yup from "yup";
import Button from "../../../ui/utils/Button";
import InputField from "../../../ui/form/InputField";
import Alert from "../../../ui/utils/Alert";
import apiRequest from "../../../../utils/admin/apiRequest";
import usePost from "../../../../hooks/api/usePost";

const CreateCountry = ({ closeModal, callback }) => {
  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.createCountry);
  const formik = useFormik({

    initialValues: {
      name: "",
      code: "",
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      code: Yup.string().required("Code is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const response = await post({ data: { body: values } });
      if (response.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Create Vendor</h2>
      <div className="border-b" />
      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}
        <div className="grid grid-cols-1 gap-2 p-4 sm:grid-cols-2">
          <InputField
            name="name"
            label="Country Name"
            placeholder="Enter Country name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && formik.errors.name}
            serverError={serverErrors?.name}
          />
          <InputField
            name="code"
            label="Country code"
            placeholder="Enter Country Code"
            value={formik.values.code}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.code && formik.errors.code}
            serverError={serverErrors?.code}
          />

        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Creating..."
            isLoading={loading}
          >
            Create
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateCountry;
